import React from "react";
import { Link } from "react-router-dom";
import { setSearch, searchText } from "../features/Blog/searchSlice";
import { useSelector, useDispatch } from "react-redux";

export default function Navbar(props) {
  const search = useSelector(searchText);
  const dispatch = useDispatch();

  return (
    <div>
      <nav class='navbar navbar-expand-md navbar-light bg-light'>
        <div class='container-lg'>
          <Link class='navbar-brand' to='/'>
            IrfanWrites
          </Link>

          <button
            class='navbar-toggler'
            type='button'
            data-mdb-toggle='collapse'
            data-mdb-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <i class='fas fa-bars'></i>
          </button>

          <div class='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul class='navbar-nav me-auto mb-2 mb-lg-0'>
              <li class='nav-item'>
                <Link class='nav-link active' aria-current='page' to='/Events'>
                  Events
                </Link>
              </li>
            </ul>

            <form class='d-flex align-items-center justify-content-between input-group w-auto'>
              <input
                type='text'
                class='form-control'
                placeholder='Search Article'
                aria-label='Search'
                value={search}
                onChange={(e) => {
                  dispatch(setSearch(e.target.value));
                }}
              />
              <button
                class='btn btn-dark'
                type='button'
                data-mdb-ripple-color='light'
              >
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>
    </div>
  );
}
